import Vue from 'vue'
import Vuex from 'vuex'
import app from '../main'
import { setCurrentLanguage } from '@/utils'
import currencies from '@/utils/currencies.json'
import menu from './modules/menu'
import auth from './modules/auth'
import fileManager from './modules/fileManager'
// pages
import categories from './modules/pages/categories'
import links from './modules/pages/links'
import products from './modules/pages/products'
import productSections from './modules/pages/productSections'
import manufacturers from './modules/pages/manufacturers'
import sliders from './modules/pages/sliders'
import hitProducts from './modules/pages/hitProducts'
import faq from './modules/pages/faq'
import options from './modules/pages/options'
import deliveryTerms from './modules/pages/deliveryTerms'
import districts from './modules/pages/districts'
import paymentTerms from './modules/pages/paymentTerms'
import pages from './modules/pages/pages'
import promocodes from './modules/pages/promocodes'
import orders from './modules/pages/orders'
import callback from './modules/pages/callback'

Vue.use(Vuex)

export const adminBaseUrl = 'api/dashboard'

export default new Vuex.Store({
  state: {
    paymentCurrency: currencies.aed
  },
  getters: {
    paymentCurrency: (state) => state.paymentCurrency
  },
  mutations: {
    changeLang(state, payload) {
      app.$i18n.locale = payload
      setCurrentLanguage(payload)
    }
  },
  actions: {
    setLang({ commit }, payload) {
      commit('changeLang', payload)
    }
  },
  modules: {
    menu,
    auth,
    fileManager,
    categories,
    links,
    products,
    productSections,
    manufacturers,
    sliders,
    hitProducts,
    faq,
    options,
    deliveryTerms,
    districts,
    paymentTerms,
    pages,
    promocodes,
    orders,
    callback
  }
})
